import {weChatrequest} from '@/utils/request'


export const getRoutesList = () => {
  return weChatrequest({
    url: '/getRouters',
    method: 'get',
  })
}

// 查询菜单列表
export function listMenu(query) {
  return weChatrequest({
    url: '/api/v1/menus',
    method: 'get',
    params: query
  })
}
// 新增菜单
export function addMenu(data) {
  return weChatrequest({
    url: '/api/v1/menus',
    method: 'post',
    data: data
  })
}

// 查询菜单详细
export function getMenu(menuId) {
  return weChatrequest({
    url: `/api/v1/menus/${menuId}/form`,
    method: 'get'
  })
}

// 查询菜单下拉树结构
export function treeselect() {
  return weChatrequest({
    url: '/system/menu/treeselect',
    method: 'get'
  })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
  return weChatrequest({
    url: '/system/menu/roleMenuTreeselect/' + roleId,
    method: 'get'
  })
}



// 修改菜单
export function updateMenu(data) {
  return weChatrequest({
    url: `/api/v1/menus/${data.id}`,
    method: 'PUT',
    data: data
  })
}

// 删除菜单
export function delMenu(menuId) {
  return weChatrequest({
    url: `/api/v1/menus/${menuId}`,
    method: 'delete'
  })
}
